import { RangeValue } from '@ui-kit/components/rangePicker';
import { ResponseUserAuthData } from '@base/features/auth/model/interfaces';
import { Moment } from 'moment';

export enum AccountRequest {
  FACE = 'face',
}

export type PersonalInfo = {
  email: string;
  login_name: string;
  question?: { question: number; answer: string };
  geo: { state?: string; country: string };
  yob: number;
  acct_value: string;
  marital_status?: string;
  gender?: string;
  about?: string;
  address: {
    country: string;
    city: string;
    zip: string;
    province?: string;
    state?: string;
    street: string;
    country_code: string;
  };
  code: number;
  user_id: string;
  avatar: {
    approved?: number;
    id?: string;
    uploaded?: string;
  };
  AdvLevel: number;
  real_name: {
    last_name: string;
    first_name: string;
  };
  status: number;
  email_verified: string;
  nopass: number;
  phone?: string;
  subscriber: string;
};

export type Session = {
  usr: string;
  session: string;
  host: string;
  port: number;
  proxy: string | string[];
};

export type Referal = {
  referedName: string;
  registrationDate: string;
  feesInTickets: number;
};

export type ReferalStatistics = {
  totalFees: number;
  percent: string;
  timeEstablished: string;
  rows: Referal[];
};

export type AccountStatement = {
  rows: Transaction[];
  total_minus: string;
  total_plus: string;
};

export type Transaction = {
  transactionType: string;
  date: string;
  time: string;
  tickets: string | number;
  balance: string | number;
};

export interface IUserService {
  /* personalInfo: Subject<PersonalInfo>; */
  isGuestPlayer(): boolean;
  openGuestModal(onClick: () => void): void;
  /* setPersonalInfo(personalInfo: PersonalInfo): void; */
  /* updatePersonalInfoValue(name: string, value: any): void; */
  /* updatePersonalInfo(): Promise<PersonalInfo>; */
  getUserInfo(): Promise<PersonalInfo>;
  getReferalFeeStatistics(range?: RangeValue): Promise<ReferalStatistics>;
  getAccountStatement(range?: RangeValue): Promise<AccountStatement>;
  setSystemAvatar(id: number, usr: string, session: string): Promise<ResponseUserAuthData>;
  setCustomAvatar(url: string, formData: FormData): Promise<ResponseUserAuthData>;
  getPartAccountInfo(part: string, usr?: string, session?: string): Promise<any>;
  canBuyTickets(usr: string, session: string): Promise<ResponseUserAuthData>;
  /* getGeoLocation(): string; */
  getPlayerStats(playerId: string): Promise<PlayerStatistics>;
  getAvatar(playerId: string): Promise<any>;
  changePassword(oldPassword: string, newPassword: string, newPasswordConfirm: string): Promise<void>;
  changeLogin(newLogin: string): Promise<void>;
  changeName(name: { firstName: string; lastName: string }): Promise<void>;
  changeEmail(newEmail: string): Promise<void>;
  changePhone(newPhone: string, firebaseToken: string): Promise<void>;
  changeAddress(address: {
    city: string;
    street: string;
    zip: string;
    state?: string;
    country?: string;
  }): Promise<void>;
  changeGender(gender: string): Promise<void>;
  changeMaritalStatus(status: string): Promise<void>;
  changeAbout(about: string): Promise<void>;
  changeYearOfBirth(yob: moment.Moment): Promise<void>;
  unsubscribeAnnoucements(): Promise<void>;
  subscribeAnnoucements(): Promise<void>;
}

export type PlayerStatistics = {
  Rank?: number;
  weekgames?: WeekGame[];
  LPoints?: number;
  Idle?: number;
  NGames?: number;
  NWon?: number;
  Streak?: number;
  BestStreak?: number;
  WinPC: string;
  NTrnGames?: number;
  NTourneys?: number;
  NTourneysWon?: number;
  NTrnGamesWon?: number;
  NMoneyGames: number;
  NChallengesWon: number;
  NChallenges: number;
  WeekWon: number;
  WeekLost: number;
  MonthWon: number;
  MonthLost: number;
  BestRank?: number;
  NRankGames: number;
  HigherRankPercent: string;
  Points?: number;
  Avatar?: string;
  Ccode?: string;
  Name: string;
  UserID: string;
};

export type WeekGame = {
  Player2: string;
  Rank1?: number;
  Fee?: string;
  TourneyID?: string;
  Player1: string;
  MyResult: string;
  ReportTime: string;
  OppId: string;
  TheirRank: string;
  MyRank: string;
  Opponent: string;
  Rank2?: number;
};

export interface IGamesHistoryService {
  getGamesHistory(gameId?: number, date?: Moment | null): Promise<GamesHistory[]>;
  getMat(logId: number, gameId?: number): Promise<LogGameHistory>;
  getGameLog(logId: number, gameId?: number): Promise<string>;
}

export type GamesHistory = {
  Amount: number;
  Date: string;
  EventType: number;
  GameLogID: number;
  Options: string;
  Player1: number;
  Player2: number;
  Reason: string;
  Result: string;
  Status: number;
  TourneyID: number;
  Usr1: string;
  Usr2: string;
  matlnk: string;
  sreason: string;
};

export type LogGameHistory = {
  Amount: string;
  Avatar1: number;
  Avatar2: number;
  Date: string;
  EventType: number;
  GameID: number;
  GameLogID: string;
  Length: number;
  Log: string;
  Options: string;
  Player1: string;
  Player2: string;
  Reason: number;
  Result: string;
  Status: number;
  TourneyID: string;
  Usr1: string;
  Usr2: string;
  code: number;
};

export const gameId: Record<string, number> = {
  backgammon: 5,
  сribbage: 4,
  'gin rummy': 3,
  'red mahjong': 9,
  dominos: 6,
};
